import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=3ca66914"
import script from "./Paragraph.vue?vue&type=script&lang=js"
export * from "./Paragraph.vue?vue&type=script&lang=js"
import style0 from "./Paragraph.vue?vue&type=style&index=0&id=3ca66914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports